import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import useBrandName from '../../hooks/useBrandName';

export default function Navbar() {
  const { isAuthenticated, logout, user } = useAuth();
  const brandName = useBrandName();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const links = [['/', 'HOME'], ['/brand', '브랜드 소개'], ['/catalog', '제품 카탈로그'], ['/oem', 'OEM/ODM 문의'], ['/contact', '연락처']] as const;
  const linkClass = (path: string) => `${location.pathname === path ? 'text-amber-400 font-semibold' : 'text-stone-200'} hover:text-amber-400 transition text-sm tracking-wide`;

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-stone-900 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl font-bold tracking-widest text-amber-400">{brandName}</span>
            <span className="text-xs text-stone-400 hidden sm:block">| 전문 브랜드 가방</span>
          </Link>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8">
            {links.map(([path, label]) => <Link key={path} to={path} className={linkClass(path)} aria-current={location.pathname === path ? 'page' : undefined}>{label}</Link>)}
            {isAuthenticated ? (
              <div className="flex items-center space-x-4">
                <Link to="/admin" className="bg-amber-500 hover:bg-amber-600 text-black font-semibold px-4 py-1.5 rounded text-sm transition">
                  관리 시스템
                </Link>
                <div className="text-xs text-stone-400">
                  <div>{user?.name}</div>
                  <button onClick={handleLogout} className="text-red-400 hover:text-red-300">로그아웃</button>
                </div>
              </div>
            ) : (
              <Link to="/login" className="border border-amber-400 text-amber-400 hover:bg-amber-400 hover:text-black px-4 py-1.5 rounded text-sm transition">
                파트너 로그인
              </Link>
            )}
          </div>

          {/* Mobile hamburger */}
          <button className="md:hidden icon-button" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'} aria-expanded={menuOpen}>
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden pb-4 space-y-2">
            {links.map(([path, label]) => (
              <Link key={path} to={path} className={`block py-2 text-sm ${location.pathname === path ? 'text-amber-400 font-semibold' : 'text-stone-200'}`} aria-current={location.pathname === path ? 'page' : undefined} onClick={() => setMenuOpen(false)}>
                {label}
              </Link>
            ))}
            {isAuthenticated
              ? <Link to="/admin" className="block py-2 text-amber-400" onClick={() => setMenuOpen(false)}>관리 시스템</Link>
              : <Link to="/login" className="block py-2 text-amber-400" onClick={() => setMenuOpen(false)}>파트너 로그인</Link>
            }
          </div>
        )}
      </div>
    </nav>
  );
}
